import React from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';


const ReportFilters = props => {
    const {
        state,
        setState,
        handleSubmit,
        searchFields,
        statusChoices,
        genericDropdown,
        officiants
    } = props;

    /* TODO: Make these keys be imported to keep things DRY */
    const storageKeys = {
        officiants: 'enduringpromises.com.reports.table.filter.officiants',
    };

    const updateState = (value, name) => {
        const data = {
            ...state,
            [name]: value,
        };
        setState(data);
    }
    const handleChange = keyName => event => {
        let value = event.target.value;
        /* TODO: make this more generic */
        if (keyName === 'officiant_ids') {
            value = [...new Set(value)]
            localStorage.setItem(storageKeys.officiants, value);
        }
        updateState(value, keyName);
    }

    const nowYear = new Date().getFullYear() + 3;
    const years = Array.from({length: 14}, (x,i) => i+(nowYear-13));
    const defaultStatuses = ['Lead','Follow-Up','Pending','Booked','Complete','Cancelled'];
    const statuses = statusChoices ? statusChoices : defaultStatuses;

    const provinces = window.provinces;

    return (
        <Grid container spacing={2} direction="row" justify="flex-start" alignItems="center">
            {state.year !== undefined && (
                <Grid item className="report-filters--year">
                    <TextField
                        style={{width: 100}}
                        select
                        id="year"
                        label="Year"
                        value={state.year}
                        onChange={handleChange('year')}
                        margin="dense"
                        variant="outlined"
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {years.map((option, i) => (
                            <MenuItem key={i} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            )}
            {state.start_date !== undefined && (
                <React.Fragment>
                    <Grid item className="report-filters--start-date">
                        <TextField
                            style={{width: 130}}
                            id="start-date"
                            label="Start Date"
                            value={state.start_date}
                            onChange={handleChange('start_date')}
                            margin="dense"
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item className="report-filters--end-date">
                        <TextField
                            style={{width: 120}}
                            id="end-date"
                            label="End Date"
                            value={state.end_date}
                            onChange={handleChange('end_date')}
                            margin="dense"
                            variant="outlined"
                        />
                    </Grid>
                </React.Fragment>
            )}
            {state.date !== undefined && (
                <Grid item className="report-filters--date">
                    <TextField
                        style={{width: 130}}
                        id="date"
                        label="Date"
                        value={state.date}
                        onChange={handleChange('date')}
                        margin="dense"
                        variant="outlined"
                    />
                </Grid>
            )}
            {state.status !== undefined && (
                <Grid item className="report-filters--status">
                    <TextField
                        style={{width: 140}}
                        select
                        id="status"
                        label="Status"
                        value={state.status}
                        onChange={handleChange('status')}
                        margin="dense"
                        variant="outlined"
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {statuses.map((option, i) => (
                            <MenuItem key={i} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            )}
            {state.province_id !== undefined && (
                <Grid item className="report-filters--province">
                    <TextField
                        style={{width: 140}}
                        select
                        id="province_id"
                        label="Province"
                        value={state.province_id}
                        onChange={handleChange('province_id')}
                        margin="dense"
                        variant="outlined"
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {provinces.map((option, i) => (
                            <MenuItem key={`province-${i}`} value={option.id}>
                                {option.province_name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            )}
            {state.search_field !== undefined && (
                <Grid item className="report-filters--search-field">
                    <TextField
                        style={{width: 140}}
                        select
                        id="search-field"
                        label="Search Field"
                        value={state.search_field}
                        onChange={handleChange('search_field')}
                        margin="dense"
                        variant="outlined"
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {searchFields.map((option, i) => (
                            <MenuItem key={`searchField-${i}`} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            )}
            {state.search !== undefined && (
                <Grid item className="report-filters--search">
                    <TextField
                        style={{width: 180}}
                        id="search"
                        label="Search"
                        value={state.search}
                        onChange={handleChange('search')}
                        margin="dense"
                        variant="outlined"
                        className="report-filters--control"
                    />
                </Grid>
            )}
            {genericDropdown !== undefined && (
                <Grid item className="report-filters--dropdown">
                    <TextField
                        style={{width: 180}}
                        select
                        id={genericDropdown.id}
                        label={genericDropdown.label}
                        value={state[genericDropdown.state_key]}
                        onChange={handleChange(genericDropdown.state_key)}
                        margin="dense"
                        variant="outlined"
                        SelectProps={{
                            autoWidth: true,
                            multiple: genericDropdown.multiple
                        }}
                    >
                        {genericDropdown.options.map((option, i) => (
                            <MenuItem key={`genericDropdown-${i}`} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            )}
            {state.officiant_ids !== undefined && officiants !== undefined && officiants.length > 0 && (
                <Grid item className="report-filters--officiants">
                    <TextField
                        select
                        style={{width: 180}}
                        id="officiants"
                        label="Officiants"
                        value={state.officiant_ids}
                        onChange={handleChange('officiant_ids')}
                        margin="dense"
                        variant="outlined"
                        SelectProps={{
                            autoWidth: true,
                            multiple: true
                        }}
                    >
                        {officiants.map((officiant) => (
                            <MenuItem key={officiant.id} value={officiant.id}>
                                {officiant.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            )}
            {state.multi_select_status !== undefined && (
                <Grid item className="report-filters--multi-select-status">
                    <TextField
                        select
                        style={{width: 180}}
                        id="status"
                        label="Status"
                        value={state.multi_select_status}
                        onChange={handleChange('multi_select_status')}
                        margin="dense"
                        variant="outlined"
                        SelectProps={{
                            autoWidth: true,
                            multiple: true
                        }}
                    >
                        {statuses.map((option, i) => (
                            <MenuItem key={`statuses-${i}`} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            )}
            <Grid item className="report-filters--submit">
                <Button variant="outlined" color="primary" size="medium" onClick={handleSubmit}>Submit</Button>
            </Grid>
        </Grid>
    )
}

export default ReportFilters;
